import { getCurrentInstance } from 'vue'

/**
 * _uid is not yet available in vue3 so I wrote a new function to generate unique id for component
 * @returns {string}
 */
export const selGenUniqueId = () => Date.now().toString(36) + Math.random().toString(36).substr(2, 5)

/**
 * Adds a class to a DOM Node.
 *
 * @param {*} item
 * @param {*} selector
 */
export const set = (item, selector) => {
  if (item instanceof Array) {
    for (const i of item) {
      i.classList.add(selector)
    }
  } else {
    item.classList.add(selector)
  }
}

/**
 * Removes a class from a DOM Node.
 *
 * @param {*} item
 * @param {*} selector
 */
export const unset = (item, selector) => {
  if (item instanceof Array) {
    for (const i of item) {
      i.classList.remove(selector)
    }
  } else {
    item.classList.remove(selector)
  }
}

/**
 * Checks to see whether a DOM Node
 * has a class.
 *
 * @param {*} item
 * @param {*} selector
 */
export const contains = (item, selector) => item.classList.contains(selector)

export const supportsObjectFit = () => {
  let objectFit = false
  for (const prop in document.documentElement.style) {
    if (/object(?:-f|F)it$/.test(prop)) {
      objectFit = true
      break
    }
  }
  return objectFit
}

export const getAppConfig = () => {
  const app = getCurrentInstance()
  const globalProperties = app.appContext.config.globalProperties.$config
  return globalProperties || {}
}

export const toPascalCase = name => name.charAt(0).toUpperCase() + name.slice(1).replace(/(-\w)/g, m => m[1].toUpperCase())
